// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3mjU1","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1g6Dx"};